import {SearchModelBase} from './SearchModelBase';
import * as XCol from '../../framework.core/XExportColumn';

export class UTFaxLogListItem extends SearchModelBase {
    postDate: string | null = null;
    fromPostDate: string | null = null;
    toPostDate: string | null = null;
    senderId: string = '';
    recCompanyName: string = '';
    recipient: string = '';
    state: string = '';
    recNo: string = '';
    title: string = '';
    whereCond: string = '';
    listTitle: string = '';
    refNo: string = '';
    hblNo: string = '';

    private static ExportCollection: XCol.XExportColumn[] = [
        XCol.Create({ col: 0, text: '', width: 30, dataIndex: 'status', hiddenInColumnSetup: true}),
        XCol.Create({ col: 1, text: 'Ref #', width: 100, dataIndex: 'refNo' }),
        XCol.Create({ col: 2, text: 'HBL #', width: 100, dataIndex: 'hblNo' }),
        XCol.Create({ col: 3, text: 'Date', width: 120, dataIndex: 'postDate', type: XCol.XCellType.DateTime, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 4, text: 'User Name', width: 100, dataIndex: 'senderId'}),
        XCol.Create({ col: 5, text: 'Company Name', width: 140, dataIndex: 'recCompanyName', defaultColumnFocus: true }),
        XCol.Create({ col: 6, text: 'Recipient', width: 140, dataIndex: 'recipient'}),
        XCol.Create({ col: 7, text: 'Status', width: 60, dataIndex: 'state'}),
        XCol.Create({ col: 8, text: 'Fax #', width: 120, dataIndex: 'recNo'}),
        XCol.Create({ col: 9, text: 'Title', width: 400, dataIndex: 'title'})
        ];


    public static getExportCollection(): XCol.XExportColumn[] {
      return this.ExportCollection;
    };
	
    public static OrderBy = { orderBy: UTFaxLogListItem.prototype.postDate, orderByAscending: false };

    public static formatData(data: UTFaxLogListItem[]) {
        return data.map((d: UTFaxLogListItem, index: number) => ({
          ...d,
          id: index + 1 //for cell focus
        }));
    }
    
    public static MapSearchFields:{[key: string]: {[key: string]: string}} = {
      postDate: {from: 'fromPostDate', to: 'toPostDate'},
    }
}
